export default "__VITE_ASSET__xewCj24___"